import { Box, Divider, MenuItem, Typography } from "@mui/material";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import SidebarPortal from "../../dashboard/general/Sidebar/Sidebar";
import WakatobiLogo from "../../../static/img/wakatobi-logo-2.svg";
import { useLocation } from "react-router-dom";
import { LogoutCurve } from "iconsax-react";
import stepIconActive from "../../../static/img/icons/step-icon-active.svg";
import stepIconDeactive from "../../../static/img/icons/step-icon-deactive.svg";
import stepIconFinish from "../../../static/img/icons/step-icon-finish.svg";
import "./styles.css";

const Sidebar = ({ soDetail }) => {
  const location = useLocation();

  const { URL_PREFIX } = window;
  const sidebarItem = [
    {
      label: "Details",
      text: "Make sure all of the guests are listed",
      status:
        location.pathname.includes("/guest-allocation") ||
          location.pathname.includes("confirmation") ||
          location.pathname.includes("summary")
          ? "done"
          : "current",
    },
    {
      label: "Allocation",
      text: "Assign each guests into their Resort and pelagians",
      status: location.pathname.includes("/guest-allocation")
        ? "current"
        : location.pathname.includes("confirmation") ||
          location.pathname.includes("summary")
          ? "done"
          : "undone",
    },
    {
      label: "Confirmation",
      text: "Double check if everything is according to your liking",
      status: location.pathname.includes("/confirmation")
        ? "current"
        : location.pathname.includes("summary")
          ? "done"
          : "undone",
    },
    {
      label: "Summary",
      text: "Sales order completed",
      status: location.pathname.includes("/summary") ? "current" : "undone",
      lastStep: true,
    },
  ];

  return (
    <SidebarPortal>
      <Box
        sx={{
          display: "flex",
          marginLeft: "20px",
          height: 50,
          marginTop: "30px",
          marginBottom: "30px",
        }}
      >
        <img src={WakatobiLogo} alt="Logo Dreams" />
      </Box>
      <Box>
        <Timeline>
          {sidebarItem.map((item) => (
            <>
              <TimelineItem>
                <TimelineSeparator>
                  {item.lastStep && item.status === "current" ? (
                    <img src={stepIconFinish} />
                  ) : item.status === "current" ? (
                    <img src={stepIconActive} />
                  ) : item.status === "undone" ? (
                    <img src={stepIconDeactive} />
                  ) : (
                    <img src={stepIconFinish} />
                  )}

                  {!item.lastStep && (
                    <TimelineConnector
                      sx={{ background: "#134264", height: "74px" }}
                    />
                  )}
                </TimelineSeparator>
                <TimelineContent>
                  <Typography className="timeline-label">
                    {item.label}
                  </Typography>
                  <Typography className="timeline-text">{item.text}</Typography>
                </TimelineContent>
              </TimelineItem>
            </>
          ))}
        </Timeline>
      </Box>
      <Box className="sidebar-footer">
        <Box sx={{ paddingBottom: "30px" }}>
          <a
            style={{ textDecoration: "none", marginLeft: "10px" }}
            href={`${URL_PREFIX}/vf1/logout`}
          >
            <MenuItem>
              <LogoutCurve color="#134264" />

              <Typography className="timeline-label">Exit</Typography>
            </MenuItem>
          </a>
        </Box>
        <Divider />
        <Box sx={{ paddingTop: "20px" }}>
          <Typography className="user-email">
            {soDetail.Email__c || ""}
          </Typography>
          <Typography className="user-so">: {soDetail?.Name || ""}</Typography>
        </Box>
      </Box>
    </SidebarPortal>
  );
};

export default Sidebar;
